import Input from 'components/Input/Input';
import InstructionBox from 'components/Instruction/InstructionBox';
import { InstructionCallout } from 'components/Instruction/InstructionCallout';
import InstructionItem from 'components/Instruction/InstructionItem';
import { AppLink } from 'components/Link/AppLink';
import COLORS from 'constants/colors';
import { useAutoScrollInstructions } from 'hooks/useAutoScrollInstructions';
import styled from 'styled-components';
import MainContainer from '../../SignInMainContainer';

interface RetrieveWebServicesUrlProps {
  apiBaseUrl: {
    value: string;
    invalid: boolean;
    onChange: (value: string, invalid?: boolean) => void;
  };
  instructionsLink?: string;
  instructionsInnerHtmlToScroll?: string;
}

const StyledInstructionBox = styled(InstructionBox)`
  margin-bottom: 12px;
`;

const RetrieveWebServicesUrl = ({
  apiBaseUrl,
  instructionsLink,
  instructionsInnerHtmlToScroll,
}: RetrieveWebServicesUrlProps) => {
  useAutoScrollInstructions(instructionsLink, instructionsInnerHtmlToScroll);

  return (
    <>
      {instructionsLink && (
        <>
          <InstructionCallout
            link={instructionsLink}
            innerHtmlToScroll={instructionsInnerHtmlToScroll}
          >
            Open{' '}
            <AppLink
              href={instructionsLink}
              rel="noreferrer"
              target="_blank"
              showInFrame
              innerHtmlToScroll={instructionsInnerHtmlToScroll}
            >
              this guide
            </AppLink>{' '}
            to find the required values. Then paste them below and click
            Connect.
          </InstructionCallout>
          <StyledInstructionBox>
            <InstructionItem index={1} badgeColor={COLORS.GRAY.GRAY_600}>
              In the search bar at the top of the page, search for &quot;Public
              Web Services&quot; and click on the resulting task
            </InstructionItem>
            <InstructionItem index={2} badgeColor={COLORS.GRAY.GRAY_600}>
              Navigate to Human Resources (Public) → Web Service → View WSDL
            </InstructionItem>
            <InstructionItem index={3} badgeColor={COLORS.GRAY.GRAY_600}>
              Find and paste the required value below
            </InstructionItem>
          </StyledInstructionBox>
        </>
      )}
      <MainContainer useNewDesign>
        <Input
          value={apiBaseUrl.value}
          onChange={(event) => apiBaseUrl.onChange(event.target.value)}
          invalid={apiBaseUrl.invalid}
          id="apiBaseUrl"
          label="Web Service URL"
        />
      </MainContainer>
    </>
  );
};

export default RetrieveWebServicesUrl;
